import React from 'react';
import { useTranslation } from 'react-i18next';

import {
	displayMoney,
	formatCurrency,
	formatWeightWithUnit,
} from 'helpers/formatter';
import {
	getStock,
	isWeightPricedProduct,
	getListPrimaryPrice,
	getListStrikePrice,
} from 'helpers/product';
import AddToCartButton from 'components/cart/AddToCartButton';
import WishlistButton from 'components/cart/WishlistButton';
import Icon from 'components/Icon';

const ProductItemMain = ({ product_id, data }) => {
	const { t } = useTranslation();
	const stock = getStock(data);

	if (!data || !data.heading_title) {
		return null;
	}

	let stockText;
	if (stock.stock === 0) {
		stockText = t('stock.unavailable');
	} else if (stock.stock === 999) {
		stockText = t('stock.inStockMany');
	} else {
		stockText = t('stock.inStockCount', { count: stock.stock });
	}

	// Форматируем отзывы - если уже есть слово "отзывов", не добавляем его снова
	const reviewsCount = data.reviews ? parseInt(data.reviews, 10) || 12 : 12;
	const reviewsText = t('product.reviewsCount', { count: reviewsCount });

	const weightPriced = isWeightPricedProduct(data);
	const mainPrice = getListPrimaryPrice(data);
	const strikePrice = getListStrikePrice(data);

	return (
		<div className='product-details-card'>
			<div className='product-details'>
				{/* Рейтинг, отзывы, артикул и избранное */}
				<div
					className='product-header-row'
					style={{
						marginBottom: '24px',
						display: 'flex',
						alignItems: 'center',
						flexWrap: 'wrap',
						gap: '16px',
					}}
				>
					<div
						className='popular-product-rating'
						style={{ position: 'static', marginRight: '8px' }}
					>
						<Icon
							name='icon-star'
							className='popular-product-rating-icon'
							ariaLabel={t('home.rating')}
						/>
						<span className='popular-product-rating-value'>
							{data.rating || '4,6'}
						</span>
					</div>
					<span className='product-reviews' style={{ marginRight: '16px' }}>
						{reviewsText}
					</span>
					<div className='product-article' style={{ marginRight: 'auto' }}>
						<span className='product-article-label'>
							{t('product.article')}
						</span>{' '}
						<span className='product-article-value'>
							{data.model || 'A-133'}
						</span>
					</div>
					<WishlistButton
						product_id={data.product_id}
						active={data.in_wishlist}
						useSvgIcon={true}
						size={24}
						iconClassName='product-favorite-button'
					/>
				</div>

				{/* Название товара */}
				<h1 className='product-title'>
					{data.heading_title}, {formatWeightWithUnit(data.weight)}
				</h1>

				{/* Метки доставки */}
				<div className='product-delivery-tags'>
					{data.weight && data.weight.includes('кг') && (
						<span className='product-delivery-tag'>
							{t('product.weightProduct')}
						</span>
					)}
					<span className='product-delivery-tag'>
						{t('product.courier')} {formatCurrency(200)}
					</span>
					<span className='product-delivery-tag'>
						{t('product.pickup')} {formatCurrency(0)}
					</span>
				</div>

				{/* Цена: слева основная строка; справа — цена за кг (весовой) или вес упаковки */}
				<div className='product-price-section'>
					<div className='product-price-row'>
						<div
							className='product-price-main'
							style={{ flexWrap: 'wrap', gap: '8px' }}
						>
							{strikePrice ? (
								<span
									className='product-price-value'
									style={{
										textDecoration: 'line-through',
										opacity: 0.65,
										fontSize: '0.9em',
									}}
								>
									{displayMoney(strikePrice)}
								</span>
							) : null}
							<span className='product-price-value'>
								{displayMoney(mainPrice)}
							</span>
							<span className='product-price-separator'> / </span>
							<span className='product-price-weight'>
								{weightPriced ? t('product.perKg') : t('product.perPiece')}
							</span>
						</div>
						{(weightPriced && data.price_kg) ||
						(!weightPriced && data.weight) ? (
							<div className='product-price-details'>
								{weightPriced ? (
									<div className='product-price-kg'>
										<span className='product-price-label'>
											{t('product.pricePerKg')}
										</span>{' '}
										<span className='product-price-value-small'>
											{displayMoney(data.price_kg)}
										</span>
									</div>
								) : (
									<div className='product-price-kg'>
										<span className='product-price-label'>
											{t('product.packWeightLabel')}
										</span>{' '}
										<span className='product-price-value-small'>
											{formatWeightWithUnit(data.weight)}
										</span>
									</div>
								)}
							</div>
						) : null}
					</div>
				</div>

				{/* Кнопка корзины и наличие */}
				<div
					className='product-cart-row'
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: '16px',
						marginBottom: '16px',
					}}
				>
					<div style={{ marginBottom: 0, flex: 1 }}>
						<AddToCartButton item={{ ...data, product_id }} />
					</div>
					<div
						className={`product-stock ${stock.stock === 0 ? 'product-stock-unavailable' : ''}`}
						style={{ marginTop: 0, whiteSpace: 'nowrap' }}
					>
						{stockText}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProductItemMain;
